import React from "react";
import Col from "react-bootstrap/Col";

import TrackCommentsContainer from "~/Containers/TrackCommentsContainer";
import TopicCommentsContainer from "~/Containers/TopicCommentsContainer";

const CommentsList = ({ track, topic }) => {
  return (
    <Col xs={12}>
      {track && Object.keys(track).length > 0 && <TrackCommentsContainer filter={track.id} track={track} render={(items) => items} />}
      {topic && topic.id && <TopicCommentsContainer topic={topic} render={(items) => items} />}
    </Col>
  );
};

export default CommentsList;
